export type RecoveryOutcome =
  | 'cancelled'
  | 'timed-out'
  | 'challenge-failed'
  | 'integration-failed'
  | 'retry-rejected';

export class RecoveryError extends Error {
  constructor(readonly outcome: RecoveryOutcome) {
    super(`Browser verification: ${outcome}`);
    this.name = 'RecoveryError';
  }
}
